// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"618":"bdca83d0","18684":"78dc2742","55529":"9638a4e4","65906":"4e2b7aa5","75077":"9638a4e4","84747":"1aee91e3","96387":"9638a4e4"}[chunkId] + ".chunk.css";
};